module.exports = __webpack_public_path__ + "a15dad17237d5cc86f44be01269883f6.pdf";